/** 設定識別ID */
export const SCREEN_ACTION_SETTING_ID = 'sales-slip-search-sas';

/**
 * 伝票検索画面動作設定インターフェース定義
 */
export interface ISalesSlipSearchScreenActionSetting {
  /** 初期表示タブ区分 */
  firstViewTabDiv: string;
  /** 初期ソート順区分 */
  initialSortOrderDiv: string;
}

/**
 * 初期表示タブ区分のenum定義
 */
export const FirstViewTabDiv = {
  /** 下書き */
  Draft: '0',
  /** ご案内中・印刷済み */
  Final: '1',
  /** 全て表示 */
  All: '2',
};

/**
 * 初期表示タブ区分の配列情報
 */
export const FirstViewTabDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '下書き' },
  { value: '1', text: 'ご案内中・印刷済み' },
  { value: '2', text: 'すべて表示' },
];

/**
 * 初期ソート順のenum定義
 */
export const InitialSortOrderDiv = {
  /** 伝票日付 */
  SlipStandardDate: '0',
  /** 更新日付 */
  UpdateDateTime: '1'
};

/**
 * 初期ソート順の配列情報
 */
export const InitialSortOrderDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: '伝票日付' },
  { value: '1', text: '更新日付' }
];

/**
 * ベースとなる伝票検索画面動作設定
 */
export const BaseScreenActionSetting: ISalesSlipSearchScreenActionSetting = {
  firstViewTabDiv: FirstViewTabDiv.Draft,
  initialSortOrderDiv: InitialSortOrderDiv.SlipStandardDate,
};



// WEBPACK FOOTER //
// ./src/app/feature/sales-slip-search-screen-action-setting-modal/sales-slip-search-screen-action-setting-modal.define.ts